import { useEffect } from "react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "flatpickr/dist/themes/material_green.css";
import ServiceTerminated from "./components/ServiceTerminated";

function App() {
  useEffect(() => {
    document.title = "VCN | Service terminated";
  }, []);

  return <ServiceTerminated />;
}

export default App;
